var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-navbar d-flex align-center"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.label,class:{
			'event-navbar__link': true,
			'event-navbar__link-active': _vm.$route.name === link.name,
		},attrs:{"to":{
			name: link.name,
			params: { id: _vm.$route.params.id },
		}}},[_vm._v(" "+_vm._s(link.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }